var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7234 18.83C22.7234 19.19 22.6434 19.56 22.4734 19.92C22.3034 20.28 22.0834 20.62 21.7934 20.94C21.3034 21.48 20.7634 21.87 20.1534 22.12C19.5534 22.37 18.9034 22.5 18.2034 22.5C17.1834 22.5 16.0934 22.26 14.9434 21.77C13.7934 21.28 12.6434 20.62 11.5034 19.79C10.3534 18.95 9.26345 18.02 8.22345 16.99C7.19345 15.95 6.26345 14.86 5.43345 13.72C4.61345 12.58 3.95345 11.44 3.47345 10.31C2.99345 9.17 2.75345 8.08 2.75345 7.04C2.75345 6.36 2.87345 5.71 3.11345 5.11C3.35345 4.5 3.73345 3.94 4.26345 3.44C4.90345 2.81 5.60345 2.5 6.34345 2.5C6.62345 2.5 6.90345 2.56 7.15345 2.68C7.41345 2.8 7.64345 2.98 7.82345 3.24L10.1434 6.51C10.3234 6.76 10.4534 6.99 10.5434 7.21C10.6334 7.42 10.6834 7.63 10.6834 7.82C10.6834 8.06 10.6134 8.3 10.4734 8.53C10.3434 8.76 10.1534 9 9.91345 9.24L9.15345 10.03C9.04345 10.14 8.99345 10.27 8.99345 10.43C8.99345 10.51 9.00345 10.58 9.02345 10.66C9.05345 10.74 9.08345 10.8 9.10345 10.86C9.28345 11.19 9.59345 11.62 10.0334 12.14C10.4834 12.66 10.9634 13.19 11.4834 13.72C12.0234 14.25 12.5434 14.74 13.0734 15.19C13.5934 15.63 14.0234 15.93 14.3634 16.11C14.4134 16.13 14.4734 16.16 14.5434 16.19C14.6234 16.22 14.7034 16.23 14.7934 16.23C14.9634 16.23 15.0934 16.17 15.2034 16.06L15.9634 15.31C16.2134 15.06 16.4534 14.87 16.6834 14.75C16.9134 14.61 17.1434 14.54 17.3934 14.54C17.5834 14.54 17.7834 14.58 18.0034 14.67C18.2234 14.76 18.4534 14.89 18.7034 15.06L22.0134 17.41C22.2734 17.59 22.4534 17.8 22.5634 18.05C22.6634 18.3 22.7234 18.55 22.7234 18.83Z",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7534 4.5H15.9534M20.7534 4.5V9.3V4.5Z",
    stroke: "#494949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutgoing);
export default __webpack_public_path__ + "static/media/call-outgoing.9356b610b2dcfa563be26c9cbac85005.svg";
export { ForwardRef as ReactComponent };